import React, {useState, useEffect} from 'react';
import CopyLink from './copyLink.js'

interface Technology {
	TechnologyShortName: string;
	MarketShare: number;
}

interface TechnologyMarketShareData {
	Technologies: Technology[];
	ThisTechologyIndex: number;
	MarketShare: number;
}

interface GoogleVisualization {
	visualization: {
		DataTable: new () => {
			addColumn: (type: string, name: string) => void;
			addRows: (rows: unknown[][]) => void;
		};
		PieChart: new (element: HTMLElement) => {
			draw: (data: unknown, options: unknown) => void;
		};
	};
}

interface Props {
	TechnologyMarketShare?: TechnologyMarketShareData;
	CategoryShortName?: string;
	TechnologyShortName?: string;
	CanonicalURL?: string;
}

interface TechnologyMarketShareProps {
	props: Props;
	google?: GoogleVisualization;
}

export default function TechnologyMarketShare({props, google}: TechnologyMarketShareProps) {
	if (!google) return null;
	if (!props.TechnologyMarketShare) return null;

	const [chart, setChart] = useState<wts_approved_any>(null);

	useEffect(() => {
		if (!props.TechnologyMarketShare) {
			return; // do not show MarketShare for non-exclusive categories
		}
		if (google && !chart) {
			// Create the data table.
			var data = new google.visualization.DataTable();
			data.addColumn('string', props.CategoryShortName!);
			data.addColumn('number', 'Market Share');
	
			if (!props.TechnologyMarketShare) return;
			
			const rows: unknown[][] = props.TechnologyMarketShare.Technologies.map(technology => [
				technology.TechnologyShortName, technology.MarketShare
			]);
	
			data.addRows(rows);
	
			// If this TechnologyMarketShare is lower than threshold (1%) 
			// then it will not show up on a pie chart
			let threshold: number = 0;
			if (props.TechnologyMarketShare.Technologies.length > 25) {
				threshold =0.01;
				if (props.TechnologyMarketShare.MarketShare < 0.01 &&
					props.TechnologyMarketShare.MarketShare > 0.005) {
						// there is no point to show too many tiny tech, unless This
						// is one of tinies.. so make an exception (sometimes)
						threshold = 0.005;			
				}
			}
		
			// Set chart options
			var options = {
				'title':`${props.CategoryShortName} market share`,
				sliceVisibilityThreshold: threshold,	 // This value corresponds to a fraction of the chart (with the whole chart being of value 1)
				pieResidueSliceLabel: "Other",
				slices: {  
					[props.TechnologyMarketShare.ThisTechologyIndex]: {
						offset: 0.2	// How far to separate the slice from the rest of the pie
					} 
				},
				'width': 600,
				'height': 400
			};
//				console.log('Technology chart drawChart point 2');
		
			// Instantiate and draw our chart, passing in some options.
			const newChart = new google.visualization.PieChart(document.getElementById('chart_div') as HTMLElement);
			newChart.draw(data, options);

			setChart(newChart);		
		} 
	},[google, chart])

	return (
		<>
            <h3 className="text-left" id="share">Market Share Overview
			<CopyLink link={props.CanonicalURL}  anchor='share'/>
			</h3>
			This chart shows {props.TechnologyShortName}’s position relative to other {props.CategoryShortName} technologies by usage volume:
            <div 
                id="chart_div" 
				style={{width: '100%'}}
            >
            </div>
        </>
	)
}

